import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'awardId',
                  },
                ],
              },
              modelId: 'ent:!awards:!award',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
